import { z } from 'zod';
import { uuidSchema } from '../../common/schemas/id.schemas.js';
import { paginatedSchema, paginationInputSchema } from '../../common/schemas/pagination.schemas.js';
/**
 * A person an estimate or a stock vehicle points at: the customer who brings the car, the buyer who
 * takes it away (plan §4). The record is deliberately thin — a name and a way to call them — because
 * the workspace is not a CRM.
 *
 * The phone is **stored normalised** (digits, with a single leading `+` when the caller gave an
 * international number) and **matched normalised**, so `+962 79 111 2233`, `079-111-2233` and
 * `0791112233` are the same person (plan §10).
 */
export const CONTACT_SEARCH_PAGE_SIZE = 10;
export const phoneInputSchema = z
    .string()
    .trim()
    .min(6, 'Enter a phone number')
    .max(32)
    .regex(/^[+]?[0-9\s().-]+$/, 'A phone number may contain digits, spaces and + ( ) - .');
export const contactSchema = z.object({
    id: uuidSchema,
    name: z.string(),
    phone: z.string(),
    email: z.string().nullable(),
    idNumber: z.string().nullable(),
    notes: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const searchContactsInputSchema = paginationInputSchema.extend({
    pageSize: z.coerce.number().int().min(1).max(50).default(CONTACT_SEARCH_PAGE_SIZE),
    /** Free text over the name, or any spelling of the phone number. */
    q: z.string().trim().min(1).optional(),
});
export const searchContactsOutputSchema = paginatedSchema(contactSchema);
export const findContactByPhoneInputSchema = z.object({
    phone: phoneInputSchema,
});
/** `null` rather than a 404: "nobody has this number yet" is the normal answer while typing. */
export const findContactByPhoneOutputSchema = contactSchema.nullable();
export const createContactInputSchema = z.object({
    name: z.string().trim().min(1, 'Enter a name').max(255),
    phone: phoneInputSchema,
    email: z.string().trim().email('Enter a valid email address').max(255).nullish(),
    idNumber: z.string().trim().max(64).nullish(),
    notes: z.string().trim().max(2_000).nullish(),
});
export const updateContactInputSchema = createContactInputSchema.partial().extend({
    contactId: uuidSchema,
});
//# sourceMappingURL=contacts.schemas.js.map